import React from "react";
import PageContainer from "../../../components/container/Container";
import WhatWeOffer from "../../../components/services/WhatWeOffer";
import { buildCloudFoundationWhatWeOffer } from "../../../data/servicesOffered";
import HowItWorks from "../../../components/services/HowItWorks";
import { buildCloudFoundationHowItWorkData } from "../../../data/howServiceWorks";
import ExclusiveFeatures from "../../../components/services/ExclusiveFeatures";
import { buildCloudFoundationFeatures } from "../../../data/exclusiveFeatures";
import bg1 from "../../../assets/images/Banner_imgs/services_1.jpg";

export default function Build_cloud_foundation() {
  return (
    <PageContainer 
      title="Build Cloud Foundation - CodeElan Technologies" 
      description="Build a secure and scalable cloud foundation aligned with your business goals. Our expert cloud foundation services ensure your infrastructure is ready for future growth."
    >
      {/* Hero Section */}
      <section className="hero-section contact-hero">
        <div className="hero-background">
          <div className="hero-overlay"></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-8 mx-auto text-center">
                <div className="hero-content">
                  <div className="hero-accent"></div>
                  <h1 className="hero-title">
                    Build <span className="text-primary">Cloud Foundation</span>
                  </h1>
                  <p className="hero-subtitle">
                    A foundation aligned with your business goals. This is step one for a successful cloud journey.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Service Description */}
      <section className="section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="service-description">
                <p className="service-text">
                  Our Build Cloud foundation services thoroughly assess your current infrastructure as an opening move toward the problem, crafting a secure and scalable architecture later. With deep expertise, we ensure your cloud solution is built for today and ready to adapt to future growth, driving agility and resilience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What We Offer */}
      <WhatWeOffer data={buildCloudFoundationWhatWeOffer} />

      {/* How It Works */}
      <HowItWorks data={buildCloudFoundationHowItWorkData} />

      {/* Exclusive Features */}
      <ExclusiveFeatures data={buildCloudFoundationFeatures} />
    </PageContainer>
  );
}
